import React, { memo } from "react";
import { ExclamationCircleFilled } from "src/icons";
import styles from "./index.module.scss";

const ChartFallback = ({ message }: any) => {
  return (
    <div className={styles["chart-fallback"]}>
      <span className={styles.icon}>{message ? <ExclamationCircleFilled /> : ""}</span>
      <div>Couldn't fetch data</div>
    </div>
  );
};

export default memo(ChartFallback);
